;(function(w){
	function LightboxContenidoHotspot(index, data){
		var self = this;
		
		setTemplate();
		setContent();

		var boton = $(this.main).find('.button-box')[0];

		$(boton).bind('click', onClickBoton);


		this.setActive = function(valor){
			if(valor){
				$(self.main).addClass('active');
			}else{
				$(self.main).removeClass('active');
			}
		}


		function setTemplate(){
			self.main = document.createElement('div');
			$(self.main).append(LightboxContenidoHotspot.template);
			self.main = self.main.firstChild;	
		}

		function setContent(){
			$(self.main).find('.bg').addClass(data.class_img);
			$(self.main).find('h4').html(data.texto);
			$(self.main).find('h4').attr('data-hover', data.texto);
			$(self.main).addClass('slideInLeft-'+(index+1));

		}

		function onClickBoton(e){
			e.preventDefault();

			var evt = jQuery.Event('LIGHTBOX_CONTENIDO_HOTSPOT_CLICK');
			evt.index = index;
			$(self.main).trigger(evt);
		}
	}

	$(document).ready(function(){
		LightboxContenidoHotspot.template = $.trim($('#lightbox_contenido_hotspot_tpl').html());
		$('#lightbox_contenido_hotspot_tpl').remove();
	});
	
	w.LightboxContenidoHotspot = LightboxContenidoHotspot;
})(window)